var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userManage_body"},[_c('headerTitle',{attrs:{"titleName":'审核管理'}}),_c('queryCom',{on:{"returnList":_vm.returnList}}),_c('tabCom',{ref:"tabCom"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }